import TextSlide from './TextSlide';

export default TextSlide;
